<template>
  <transition name="fade">
    <div v-if="visible" class="dialog-mask" @click.self="handleClose">
      <transition name="zoom">
        <div class="dialog-box" v-show="visible" :style="{ width, borderRadius }">
          <div class="dialog-content">
            <div class="type-list">
              <div class="type-item" :style="'width:'+(100/newMenuList.length)+'%'"
                   v-for="(item,index) in newMenuList" :key="index" @click.stop="selectType(index,item)">
                <div class="type-item-name"
                     :style="(selectIndex == index || item.showName)?'color:'+themeColor:''">
                  {{ item.showName || item.name }}
                </div>
              </div>
            </div>
            <div @touchmove.stop="onTouchMove" class="scroll-popup" :style="scrollPopup" v-if="isShow">
              <div v-if="itemList.length> 0">
                <item1 v-if="showType==1" :itemList="itemList" :isMultiple="isMultiple" :themeColor="themeColor"
                       @complete="complete"></item1>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import item1 from './item1.vue'

export default {
  components: {
    item1,
  },
  props: {
    //菜单数据源
    menuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    //下拉框数据源
    dataObj: {
      type: Object,
      default: {}
    },
    //菜单到顶部距离(px)
    top: {
      type: Number,
      default: 0,
    },
    //主题色
    themeColor: {
      type: String,
      default: '#62BF99',
    },
    //圆角(px、px、%)
    radius: {
      type: String,
      default: '12px',
    },
    //是否点击阴影关闭
    isMask: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dataObj: {
      deep: true,
      immediate: true,
      handler(obj) {
        if (obj.itemList1) {
          this.canChoose = true
        }
      },
    },
    menuList: {
      deep: true,
      immediate: true,
      handler(newArr) {
        if (newArr.length) {
          this.newMenuList = newArr
        }
      },
    },
    visible(newVal) {
      if (newVal) {
        this.selectType(0, this.newMenuList[0])
      } else {
      }
    }
  },
  data() {
    return {
      isShow: false,
      selectIndex: -1,
      screenWidth: 0,
      isMultiple: false,
      showType: 0,
      itemList: [],
      newMenuList: [],
      canChoose: false
    };
  },
  computed: {
    popupBox() {
      return `top : ${this.top + 'px'};
				border-radius: 0 0  ${this.radius} ${this.radius};`;
    },
    scrollPopup() {
      return `opacity: ${this.isShow ? 1 : 0};`;
    },
  },
  mounted() {
  },
  methods: {
    open() {
      this.isShow = true
    },
    handleCancel() {
      this.$emit('cancel')
      this.close()
    },
    handleConfirm() {
      this.$emit('confirm')
      this.close()
    },
    close() {
      this.selectIndex = -1
      this.isShow = false
      this.$emit('close')
    },
    selectType(index, item) {
      if (!this.canChoose) return
      if (this.selectIndex == index) {
        this.close()
      } else {
        this.selectIndex = index
        let idx = this.selectIndex + 1
        this.itemList = this.dataObj['itemList' + idx]
        this.isMultiple = this.selectIndex > -1 && this.menuList[this.selectIndex].isMultiple ?
          this.menuList[this.selectIndex].isMultiple : false
        this.showType = this.menuList[this.selectIndex].showType
        this.open()
        this.$emit('chooseType', this.selectIndex)
      }
    },
    //选择成功
    complete(obj) {
      let list = obj.list
      let type = obj.type
      let idx = this.selectIndex + 1
      this.dataObj['itemList' + idx] = JSON.parse(JSON.stringify(list))
      if (type == 1) { //有子集
        list.forEach(res => {
          res.childs = res.childs.filter(item => item.chooseState)
        })
        let newList = list.filter(item => item.childs.length > 0)
        if (newList.length > 0) {
          let arr = []
          newList.forEach(res => {
            res.childs.forEach(item => {
              arr.push(item.name)
            })
          })
          this.menuList[this.selectIndex].showName = arr.toString()
        } else {
          this.menuList[this.selectIndex].showName = ''
        }
      } else { //无子集
        let newList = list.filter(item => item.chooseState)
        if (newList.length > 0) {
          let arr = []
          newList.forEach(item => {
            arr.push(item.name)
          })
          this.menuList[this.selectIndex].showName = arr.toString()
        } else {
          this.menuList[this.selectIndex].showName = ''
        }
      }
      let chooseObj = JSON.parse(JSON.stringify(this.dataObj))
      for (let i in chooseObj) {
        if (chooseObj[i][0] && chooseObj[i][0].childs) {
          chooseObj[i].forEach(item => {
            item.childs = item.childs.filter(mes => mes.chooseState)
          })
          chooseObj[i] = chooseObj[i].filter(mes => mes.childs.length > 0)
        } else {
          chooseObj[i] = chooseObj[i].filter(mes => mes.chooseState)
        }
      }
      this.$emit('change', {
        chooseMenu: this.menuList[this.selectIndex],
        chooseInfo: chooseObj
      })
      this.close()
    },
    onTouchMove(event) {
      if (this.isShow) {
        event.stopPropagation(); // 阻止冒泡
      }
    },
  },
};
</script>

<style scoped>
/* 遮罩层，百分百占满视口，高度必须 100vh */
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 弹窗主体 */
.dialog-box {
  background: #fff;
  max-width: 80vw;
  width: auto;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  text-align: center;
  /* 💡 防止动画偏移 */
  transform-origin: center;
}

.dialog-content {
  display: flex;
  flex-direction: column;
}

.dialog-image {
  width: 100%;
  max-height: 550px;
  object-fit: cover;
}

.dialog-title {
  font-size: 20px;
  margin: 8px 0;
  color: #333;
}

.dialog-text {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
}

/* ✅ 按钮区域 */
.dialog-actions {
  display: flex;
  justify-content: space-around;
  margin-top: 12px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
  padding: 0 24px;
  border: none;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn.cancel {
  background: #eee;
}

.btn.cancel:hover {
  background: #ddd;
}

.btn.confirm {
  background: #409eff;
  color: white;
}

.btn.confirm:hover {
  background: #337ecc;
}

/* ✅ 动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.zoom-enter-active, .zoom-leave-active {
  transition: all 0.25s cubic-bezier(0.3, 0.8, 0.3, 1.2);
}

.zoom-enter, .zoom-leave-to {
  transform: scale(0.85);
  opacity: 0;
}

.type-list {
  width: 100%;
  border-bottom: solid #F4F4F4 1px;
  padding: 10px 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  .type-item {
    display: flex;
    align-items: center;
    justify-content: center;

    .type-item-name {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .type-item-icon {
      margin-left: 10px;
      min-width: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      .type-item-icon-img {
        width: 17px;
        height: 12px;
      }
    }
  }
}

</style>
